<form [formGroup]="form" *ngIf="form">
  <ion-item-divider color="light">
    <ion-label>{{ dividerTitle  | translate }}</ion-label>
  </ion-item-divider>

  <ion-row>
    <!-- Game Type -->
    <ion-col>
      <ion-item>
        <ion-select label="{{ 'Game type' | translate }}" label-placement="stacked" interface="popover" formControlName="gameType">
          <ion-select-option [value]="'RALLY'">{{ 'Rally' | translate }}</ion-select-option>
          <!-- <ion-select-option [value]="'ENGLISH_HIHO'">{{ 'English (HiHo)' | translate }}</ion-select-option> -->
        </ion-select>
      </ion-item>
    </ion-col>

    <!-- Number of Games -->
    <ion-col>
      <ion-item>
        <ion-select label="{{ 'Games' | translate }}" label-placement="stacked" interface="popover" formControlName="numberOfGames">
          <ion-select-option [value]="1">1</ion-select-option>
          <ion-select-option [value]="3">3</ion-select-option>
          <ion-select-option [value]="5">5</ion-select-option>
        </ion-select>
      </ion-item>
    </ion-col>
  </ion-row>

  <ion-row>
    <!-- Points per Game -->
    <ion-col>
      <ion-item>
        <ion-select label="{{ 'Points per game' | translate }}" label-placement="stacked" interface="popover" formControlName="numberOfPoints">
          <!-- Rally scoring options -->
          <ion-select-option *ngIf="form.get('gameType')?.value === 'RALLY'" [value]="11">11</ion-select-option>
          <ion-select-option *ngIf="form.get('gameType')?.value === 'RALLY'" [value]="15">15</ion-select-option>
          <ion-select-option *ngIf="form.get('gameType')?.value === 'RALLY'" [value]="21">21</ion-select-option>
          <!-- English (HiHo) scoring options -->
          <ion-select-option *ngIf="form.get('gameType')?.value === 'ENGLISH_HIHO'" [value]="9">9</ion-select-option>
          <ion-select-option *ngIf="form.get('gameType')?.value === 'ENGLISH_HIHO'" [value]="15">15</ion-select-option>
        </ion-select>
      </ion-item>
    </ion-col>
  </ion-row>
</form>

